import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import { GdsCommonUtilityService } from '@upr-web-primer/gds-common-utility';
import { get } from 'lodash-es';
class GdsImageLinkModelModule {
  static {
    this.ɵfac = function GdsImageLinkModelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsImageLinkModelModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsImageLinkModelModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsImageLinkModelModule, [{
    type: NgModule,
    args: [{}]
  }], null, null);
})();
class GdsImageLinkModelService {
  constructor(injector) {
    this.injector = injector;
  }
  get utilities() {
    if (!this._utilities) {
      this._utilities = this.injector.get(GdsCommonUtilityService);
    }
    return this._utilities;
  }
  init(field, isXpath) {
    const embeddedValues = get(field, 'EmbeddedValues', []);
    const imageButtonArray = [];
    if (['iconImage', 'landLogo'].includes(field.Name)) {
      const iconImage = this.utilities.getImageUrl(field, 'Multimedia', isXpath);
      return iconImage;
    } else {
      for (let i = 0; i <= embeddedValues.length - 1; i++) {
        imageButtonArray.push({
          image: this.utilities.getImageUrl(field, 'image', true, i, isXpath),
          title: isXpath ? get(field, `EmbeddedValues[${i}].title.XPath`) : get(field, `EmbeddedValues[${i}].title.Values[0]`),
          href: this.utilities.getHref(embeddedValues[i]),
          analytics: get(field, `EmbeddedValues[${i}].analytics.Values[0]`),
          target: get(field, `EmbeddedValues[${i}].target.KeywordValues[0].Key`),
          ariaLabel: get(field, `EmbeddedValues[${i}].ariaLabel.Values[0]`),
          style: get(field, `EmbeddedValues[${i}].style.KeywordValues[0].Key`, '')
        });
      }
      return imageButtonArray;
    }
  }
  static {
    this.ɵfac = function GdsImageLinkModelService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsImageLinkModelService)(i0.ɵɵinject(i0.Injector));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsImageLinkModelService,
      factory: GdsImageLinkModelService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsImageLinkModelService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i0.Injector
  }], null);
})();

/*
 * Public API Surface of gds-image-link-model
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GdsImageLinkModelModule, GdsImageLinkModelService };
